<template>
  <div class="md-layout md-size-80 new-user-wrap">
    <template v-if="!userCreated">
      <md-field class="md-layout-item md-size-45 md-medium-size-100">
        <label>First Name</label>
        <md-input v-model="newPerson.first_name" type="text"></md-input>
      </md-field>
      <md-field class="md-layout-item md-size-45 md-medium-size-100">
        <label>Last Name</label>
        <md-input v-model="newPerson.last_name" type="text"></md-input>
      </md-field>
      <md-field class="md-layout-item md-size-45">
        <label>Email</label>
        <md-input v-model="newPerson.email" type="text"></md-input>
      </md-field>
      <md-field class="md-layout-item md-size-45">
        <label>Phone</label>
        <md-input v-model="newPerson.phone_number" type="text"></md-input>
      </md-field>
      <md-field class="md-layout-item md-size-95" v-if='company.company_type == "facility"'>
        <label>Select Facility</label>
        <md-select v-model="newPerson.facility_id" name="facility_id" id="facility_id" required>
          <md-option v-for="facility in facilities" :key="facility.id" :value="facility.id" v>{{ facility.name }}
          </md-option>
        </md-select>
      </md-field>

      <md-field class="radio md-layout-item md-size-95">
        <!-- <label>Owner or Employee?</label> -->
        <md-radio v-model="newPerson.uType" value="owner">Admin</md-radio>
        <md-radio v-model="newPerson.uType" value="employee">Employee</md-radio>
      </md-field>

      <div style="text-align: center;">
        <md-button class="md-success md-sm" @click="inviteUser">Add New User</md-button>
      </div>
    </template>
    <div class="" v-else>
      {{ newPerson.name }} has been added to your company!
    </div>
  </div>
</template>
<script>
import api from '@/api';
import idx from 'idx';
export default {
  components: {
  },
  name: 'UserInvite',
  props: [
    'showUserInvite'
  ],
  data() {
    return {
      responsive: false,
      userCreated: false,
      newPerson: {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        uType: '',
        facility_id: null,
      },
      company_name: '',
      facilities: [],
      company: {}
    }
  },

  created() {
    this.company = this.$store.state.company;
    if (this.company && this.company.company_type == 'facility') {
      this.company_name = this.$store.state.company.company_name;
      const companyId = this.$store.state.company.id;
      api.getCompanyDataAdmin(companyId).then((response) => {
        this.facilities = response.data.facilities;
        // this.isLoading = false;
      });
    }
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    notifyVue(message, color) {
      console.log('here2');
      console.log(this.$notify);
      // var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        timeout: 3000,
        message: message,
        horizontalAlign: 'left',
        verticalAlign: 'top',
        type: color
      });
    },
    inviteUser() {
      api.inviteNewUser(this.newPerson).then((response) => {
        if (response.data.status == 201) {
          var newU = response.data.newUser
          // newU.level = this.newPerson.level
          var message = `${this.newPerson.email} has been added to your company as an ${this.newPerson.uType}.`
          this.notifyVue(message, "success");
          this.$emit("closeBox", newU);
        }
        this.userCreated = true;
        //close the box
      }).catch((errors) => {
        console.log(errors);
      })
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  }
}
</script>
<style lang="scss" scoped>
.radio {
  .md-radio {
    // position: relative;
    display: flex;
    // padding: 0 20px;
    align-items: center;
    justify-content: flex-start;

    .md-radio-container {
      // vertical-align: center;
      // align-items: center;
    }

    .md-radio-label {
      // align-items: center;
      // height: 40px;
      padding-left: 10px;
      // position: static;
      line-height: 10px;
    }
  }
}

.new-user-wrap {
  justify-content: space-around;

}
</style>
